export {
  createVertexMaas,
  vertexMaas,
} from './google-vertex-maas-provider-edge';
export type {
  GoogleVertexMaasProvider,
  GoogleVertexMaasProviderSettings,
} from './google-vertex-maas-provider-edge';
export type { GoogleVertexMaasModelId } from '../google-vertex-maas-options';
